import React, { useState } from "react";

import { Button, Grid, Tooltip } from "@mui/material";
import blogEditIcon from "../../assets/icons/edit-blog-icon.svg";
// import userSettingIcon from "../../assets/icons/user-setting.svg"
import blogDeactivateIcon from "../../assets/icons/deactivate-blog-icon.svg";
import blogActivateIcon from "../../assets/icons/activate-blog-icon.svg";
import { useLocation } from "react-router-dom";
import CommonModal from "../../components/modal/CommonModal";
import DeactivateBlogModalBody from "./DeactivateBlog";
import ActivateBlogModalBody from "./ActivateBlog";
import EditBlogModalBody from "./EditBlog";
import styles from "./postBlog.module.scss";

export const ManageBlog = ({
  blogDetails,
  isActive,
  pageState,
  getBlogsList,
}: any) => {
  const [openDeactivateBlog, setOpenDeactivateBlog] = useState(false);
  const [openActivateBlog, setOpenActivateBlog] = useState(false);
  const handleOpenDeactivateBlogModal = () => setOpenDeactivateBlog(true);
  const handleCloseDeactivateBlogModal = () => setOpenDeactivateBlog(false);
  const [openEditBlog, setOpenEditBlog] = useState(false);
  const { pathname } = useLocation();
  const isBlog = pathname.includes("/blogs-management");

  const handleOpenEditBlogModal = () => setOpenEditBlog(true);
  const handleCloseEditBlogModal = () => setOpenEditBlog(false);

  const handleOpenActivateBlogModal = () => setOpenActivateBlog(true);
  const handleCloseActivateBlogModal = () => setOpenActivateBlog(false);
  return (
    <>
      <CommonModal
        open={openDeactivateBlog}
        handleCloseModal={handleCloseDeactivateBlogModal}
        modalBody={
          <DeactivateBlogModalBody
            isActive={isActive}
            handleCloseModal={handleCloseDeactivateBlogModal}
            blogDetails={blogDetails}
            pageState={pageState}
            getBlogsList={getBlogsList}
          />
        }
      />
      <CommonModal
        open={openActivateBlog}
        handleCloseModal={handleCloseActivateBlogModal}
        modalBody={
          <ActivateBlogModalBody
            isActive={isActive}
            handleCloseModal={handleCloseActivateBlogModal}
            blogDetails={blogDetails}
            pageState={pageState}
            getBlogsList={getBlogsList}
          />
        }
      />
      <CommonModal
        className={styles.editModalStyle}
        open={openEditBlog}
        handleCloseModal={handleCloseEditBlogModal}
        modalBody={
          <EditBlogModalBody
            isActive={isActive}
            handleCloseModal={handleCloseEditBlogModal}
            blogDetails={blogDetails}
            pageState={pageState}
            getBlogsList={getBlogsList}
          />
        }
      />
      <Grid container columnSpacing={2}>
        <Grid item xs={4} spacing={2}>
          <Tooltip title={isBlog ? "Update Blog" : "Update News"}>
            <Button onClick={handleOpenEditBlogModal}>
              <img
                src={blogEditIcon}
                alt="edit icon"
                height="20px"
                width="20px"
              />
            </Button>
          </Tooltip>
        </Grid>
        <Grid item xs={4}>
          <Tooltip
            title={`${isActive ? "Deactivate" : "Activate"} ${
              isBlog ? "Blog" : "News"
            }`}
          >
            <Button
              onClick={
                isActive
                  ? handleOpenDeactivateBlogModal
                  : handleOpenActivateBlogModal
              }
            >
              <img
                src={isActive ? blogDeactivateIcon : blogActivateIcon}
                alt="icon"
                height="20px"
                width="20px"
              />
            </Button>
          </Tooltip>
        </Grid>
        {/* <Grid item xs={4}>
          <Tooltip title="User Settings">
            <Button onClick={()=>navigate("/")}>
              <img src={userSettingIcon} alt="setting icon" height="20px" width="20px" />
            </Button>
          </Tooltip>
        </Grid> */}
      </Grid>
    </>
  );
};
